const header = {
  systemTitle: '사출 통합 관제 시스템',
  logoAlt: '로고',
  notice: '공지사항',
  noticeEmpty: '공지사항이 없습니다',
  noticeCount: '{count}건',
  noticeBadge: {
    urgent: '긴급',
    update: '업데이트',
    notice: '공지',
    general: '일반',
  },
  alarmStatus: '알람 현황',
  alarmCount: '{count}건',
  alarmLoading: '알람 로딩 중...',
  alarmNone: '알람 없음',
  noticeAll: '공지 전체 보기',
  noticeViews: '조회 {count}',
  bell: '알림센터',
  ticker: {
    count: '{sev} {count}건',
    prev: '이전 알람',
    next: '다음 알람',
    list: '알림센터 열기',
    openDetail: '알람 상세 보기',
  },
  toast: {
    detail: '설비 상세 보기',
    ack: '확인',
  },
  center: {
    title: '알림센터',
    unread: '미확인 {count}',
    subtitle: '전체 알람의 원본 · 행을 누르면 상세로 이동합니다',
    all: '전체 {count}',
    unreadChip: '미확인 {count}',
    severityAll: '심각도 전체',
    ackAll: '모두 확인',
    history: '전체 이력 보기',
    acked: '확인됨',
    empty: '표시할 알람이 없습니다',
    ackNote: '확인·음소거 상태는 이 브라우저에만 저장됩니다 (서버 확인 API 없음)',
  },
  detail: {
    position: '{sev} {n}건 중 {i}',
    prev: '이전',
    next: '다음 알람',
    list: '전체 목록',
    cause: '원인',
    codeLabel: '알람 코드 {code}',
    typeLabel: '유형 {type}',
    indicators: '발생 지표',
    indicatorNote: '최근 샷 기준 (알람 시점 값 아님)',
    maxPressure: '최대사출압',
    cushion: '사출완료 위치',
    cycleTime: '사이클타임',
    quick: '빠른 조치',
    ack: '확인 (ACK)',
    acked: '확인됨',
    mute: '음소거 30분',
    muted: '음소거 중 ~{time}',
    goEquipment: '설비 상세로 이동 · 알람 탭',
    askAi: 'AI에게 원인 묻기',
    alarmId: '알람 ID {id}',
    history: '전체 이력 보기',
    timeAgoAt: '{time} ({ago})',
    askQuestion: '{equipment}에서 발생한 "{message}" 알람(코드 {code})의 원인과 조치 방법을 알려줘',
  },
  ai: {
    fab: '묻기',
    title: 'AI 어시스턴트',
    openFull: '전체 분석 열기',
    context: '현재 맥락',
    empty: '현장 데이터에 대해 무엇이든 물어보세요',
    suggestionsTitle: '추천 질문 (현재 화면 기준)',
    q1: '최근 24시간 알람이 가장 많은 설비는?',
    q2: '오늘 불량률이 가장 높은 설비는?',
    q3: '지금 가동 중인 설비는 몇 대야?',
    placeholder: '현장 용어로 물어보세요…',
    send: '전송',
    thinking: '분석 중…',
    failed: 'AI 서비스에 연결하지 못했습니다',
    noAnswer: '답변을 만들지 못했습니다',
    newChat: '새 대화',
    newChatHint: '지금 대화를 지우고 새로 시작합니다',
  },
  collection: {
    loading: '수집 확인 중...',
    title: '데이터 수집 현황',
    factoryCount: '공장 {count}곳',
    statusNoEquipment: '설비 없음',
    stoppedBadge: '정지 {count}대',
    allNormal: '모든 설비에서 데이터가 정상 수집되고 있습니다',
    empty: '등록된 공장이 없습니다',
    countRunning: '가동중',
    countIdle: '대기',
    countStopped: '정지',
    neverCollected: '수집 이력 없음',
    elapsedMin: '{n}분 전',
    elapsedHour: '{n}시간 전',
    elapsedDay: '{n}일 전',
  },
};

export default header;
